<template>
    <div>{{ item.title }}</div>
</template>

<script>
export default {
    name: 'NestedHeading',

    props: {
        item: {
            required: true,
            type: Object,
        },
    },
};
</script>
